import dayjs from 'dayjs';
import { addDays, monthGrid, overlapsRange, type TypeRange } from './calendar.range';

export type TypeWindowKey = string;

export const WINDOW_KEY = 'YYYY-MM';

export const windowKey = (date: Date | string): TypeWindowKey => dayjs(date).format(WINDOW_KEY);

export const windowRange = (key: TypeWindowKey): TypeRange => {
    const grid = monthGrid(dayjs(`${key}-01`).toDate());
    return { from: grid[0], to: addDays(grid[grid.length - 1], 1) };
};

export const windowKeysAround = (anchor: Date): TypeWindowKey[] => {
    const month = dayjs(anchor).startOf('month');
    return [month.subtract(1, 'month'), month, month.add(1, 'month')].map((entry) => entry.format(WINDOW_KEY));
};

export const windowKeysFor = (startAt: string, endAt: string): TypeWindowKey[] => {
    const first = dayjs(startAt).startOf('month').subtract(1, 'month');
    const last = dayjs(endAt).startOf('month').add(1, 'month');

    const keys: TypeWindowKey[] = [];
    for (let month = first; !month.isAfter(last); month = month.add(1, 'month')) {
        const key = month.format(WINDOW_KEY);
        if (overlapsRange(startAt, endAt, windowRange(key))) keys.push(key);
    }

    return keys;
};
